import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@glu/theming';
import { ButtonToggleContext } from './ButtonToggleGroup';
import styles from './ButtonToggle.styles';
import registerDefaults from './themeDefaults';

registerDefaults();

export const BareButtonToggle = ({
  id, children, className, classes, ...rest
}) => {
  const { onButtonSelected, selectedButtonId } = useContext(ButtonToggleContext);
  const onClick = useCallback(() => onButtonSelected(id), [id, onButtonSelected]);

  return (
    <button
      className={`${classes.root} ${className} ${selectedButtonId === id ? classes.selected : ''}`}
      type="button"
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  );
};

BareButtonToggle.propTypes = {
  /** Unique id for the button within its group */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  /** Child components to render inside button toggle */
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.element]),

  /** CSS class to add if desired */
  className: PropTypes.string,

  /** Classes for JSS styling */
  classes: PropTypes.shape({
    root: PropTypes.string,
    selected: PropTypes.string
  }).isRequired
};

BareButtonToggle.defaultProps = {
  children: undefined,
  className: ''
};

const ButtonToggle = withStyles(styles)(BareButtonToggle);
ButtonToggle.displayName = 'ButtonToggle';
export default ButtonToggle;
